export default __webpack_public_path__ + "meetingroomautticket1.json";